<div class="d-flex flex-row flex-wrap align-items-center justify-content-start title-header-cont container-fluid">
  <div class="top-heading-title">
    <div class="title">Pixalate Rankings</div>
  </div>
  <div aria-label="Rankings Type Toggle" class="btn-group toggle-filter rankings-toggle-filter" role="group">
    <button class="btn btn-secondary" (click)="rankingGroupSelect('ctv')" [ngClass]="{active: selectedGroup === 'ctv'}"
      type="button">
      Connected TV
    </button>
    <button class="btn btn-secondary" (click)="rankingGroupSelect('app')" [ngClass]="{active: selectedGroup === 'app'}"
      type="button">
      Mobile
    </button>
    <button class="btn btn-secondary" (click)="rankingGroupSelect('domain')"
      [ngClass]="{active: selectedGroup === 'domain'}" type="button">
      Website
    </button>
  </div>
  <div class="lastUpdatedMonthLabel"
    [ngClass]="{'flex-expand': currentConfig?.key === 'seller-trust-index' || currentConfig?.key === 'seller-market-share' || currentConfig?.key === 'device-reach' || currentConfig?.key === 'device-market-share'}">
    Last Updated: {{lastUpdatedMonthLabel}}
  </div>
</div>
<div class="rankings-main-content">
  <div class="side-navigation rankings" #sideNav [ngClass]="{collapsed: tabletNavCollapsed}">
    <div class='side-navigation-scroll-container'>
      <ng-container *ngFor="let map of sideNavItemsMaps">
        <ng-container *ngIf="!map?.groups || map?.groups.indexOf(selectedGroup) >= 0">
          <div class="sidenav-group" [ngClass]="{ active: currentSideItemMap?.id === map.id }">
            <h5 [ngClass]="{ active: map.active  && isSummary }">
              <div class="logo-cont">
                <ng-container *ngIf="map.id === 'top-seller'">
                  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.42 18.77L14.14 15.45M7.81 15.39L4.6 17.8M6.9 4.79L9.22 9.44M14.56 11.22L17.21 9.89M8 3C8
              4.10457 7.10457 5 6 5C4.89543 5 4 4.10457 4 3C4 1.89543 4.89543 1 6 1C7.10457 1 8 1.89543 8 3ZM22 20C22
              21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 18.8954 18.8954 18 20 18C21.1046 18 22 18.8954 22
              20ZM21 9C21 10.1046 20.1046 11 19 11C17.8954 11 17 10.1046 17 9C17 7.89543 17.8954 7 19 7C20.1046 7 21
              7.89543 21 9ZM5 19C5 20.1046 4.10457 21 3 21C1.89543 21 1 20.1046 1 19C1 17.8954 1.89543 17 3 17C4.10457 17
              5 17.8954 5 19ZM15 13C15 15.2091 13.2091 17 11 17C8.79086 17 7 15.2091 7 13C7 10.7909 8.79086 9 11 9C13.2091
              9 15 10.7909 15 13Z" stroke="#2652B2" stroke-width="2" stroke-miterlimit="10" />
                  </svg>
                </ng-container>
                <ng-container *ngIf="map.id === 'top-publisher'">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 5V4L3 5H4ZM8 5V6L9 5H8ZM8 1V0L7 1H8ZM16 1H17L16 0V1ZM16 5H15L16 6V5ZM20 5H21L20 4V5ZM9
                  17V16H8V17H9ZM15 17H16V16H15V17ZM15 23H14V24H15V23ZM5 23V5H3V23H5ZM4 6H8V4H4V6ZM9 5V1H7V5H9ZM8
                  2H16V0H8V2ZM15 1V5H17V1H15ZM16 6H20V4H16V6ZM19 5V23H21V5H19ZM10 23V17H8V23H10ZM9 18H15V16H9V18ZM14
                  17V23H16V17H14ZM0 24H15.87V22H0V24ZM15 24H23.87V22H15V24ZM7 8V13H9V8H7ZM11 8V13H13V8H11ZM11
                  3V6H13V3H11ZM15 8V13H17V8H15Z" fill="#2652B2" />
                  </svg>
                </ng-container>
                <ng-container *ngIf="map.id === 'top-device'">
                  <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 20H13M2 12H13M21 7V2.09C21 1.49 20.51 1 19.91 1H2.09C1.49 1 1 1.49 1 2.09V14.91C1 15.51
                1.49 16 2.09 16H13M11 19V16M22 22H16C15.45 22 15 21.55 15 21V10C15 9.45 15.45 9 16 9H22C22.55 9 23
                9.45 23 10V21C23 21.55 22.55 22 22 22Z" stroke="#2652B2" stroke-width="2" stroke-miterlimit="10" />
                  </svg>
                </ng-container>
              </div>
              {{map.title}}
            </h5>
            <ul class="nav flex-column">
              <ng-container *ngFor="let sideNavItem of map.sideNavItems">
                <li class="nav-item active"
                  *ngIf="!sideNavItem?.groups || sideNavItem?.groups.indexOf(selectedGroup) >= 0">
                  <a class="nav-link" [routerLink]="['/rankings', selectedGroup, sideNavItem?.id]"
                    [ngClass]="{active: currentSideNavItem && currentSideNavItem.id === sideNavItem.id}">
                    <div class="d-flex">
                      <div class="nav-link-icon-cont">
                        <ng-container *ngIf="sideNavItem?.icon; else sidenavicon">
                          <img width="24" src="/assets/images/{{sideNavItem?.icon}}" alt="Icon" />
                        </ng-container>
                        <ng-template #sidenavicon>
                          <img src="/assets/images/icon-{{sideNavItem.id}}.png" alt="Icon" />
                        </ng-template>
                      </div>
                      <div>{{sideNavItem.title}}</div>
                    </div>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </ng-container>
      <app-rankings-sidenav-links [currentConfig]="currentConfig"></app-rankings-sidenav-links>
      <button class="btn btn-toggle-tablet-nav" (click)="tabletNavCollapsed = !tabletNavCollapsed">
        <i class="fa fa-angle-double-right"></i>
        <i class="fa fa-angle-double-left"></i>
      </button>
    </div>
  </div>
  <div class="right-content rankings {{currentConfig?.key}} {{selectedGroup}}"
    [ngClass]="{ 'show-anon-form': showAnonForm }" *ngIf="isSummary || isPermitted">
    <div class="main-content" [ngClass]="{'loading': loading, 'loadingData': loadingData}">
      <div class="d-flex justify-content-between rankings-heading">
        <ng-container *ngIf="!isSummary">
          <div class='d-flex align-items-center'>
            <div class='rankings-header'>
              <div class="rankings-heading-title">
                {{currentConfig?.heading}}
              </div>
              <h2 class="title">
                <ng-container *ngIf="currentConfig?.showTitle; else defaulttitle;">
                  <ng-container *ngIf="!loading">
                    {{currentConfig?.title |
                    rankingsLabelParse:selectedGroup:currentConfig?.mainFilterItems:currentConfig?.key | capitalize}}
                  </ng-container>
                </ng-container>
                <ng-template #defaulttitle>
                  <ng-container *ngIf="currentConfig?.key !== 'seller-trust-index' && currentConfig?.key !== 'seller-market-share'
                  && currentConfig?.key !== 'seller-childrens-privacy'">
                    <ng-container *ngIf="currentConfig?.key === 'high-risk-mfa'">High Risk</ng-container>
                    <ng-container *ngIf="selectedGroup === 'domain'">
                      Websites</ng-container>
                    <ng-container *ngIf="selectedGroup === 'app'">
                      Mobile {{currentConfig?.key === 'device-reach' || currentConfig?.key === 'device-market-share' ?
                      'Devices' : 'Apps'}}</ng-container>
                    <ng-container *ngIf="selectedGroup === 'ctv'">
                      Connected TV {{currentConfig?.key === 'device-reach' || currentConfig?.key ===
                      'device-market-share' ?
                      'Devices' : 'Apps'}}</ng-container>
                  </ng-container>
                  <ng-container *ngIf="currentConfig?.key === 'seller-trust-index' || currentConfig?.key === 'seller-market-share'
                   || currentConfig?.key === 'seller-childrens-privacy'">
                    <ng-container *ngIf="currentConfig?.key !== 'seller-childrens-privacy'">Top&nbsp;</ng-container>
                    <ng-container *ngIf="selectedGroup === 'domain'">Website</ng-container>
                    <ng-container *ngIf="selectedGroup === 'app'">Mobile</ng-container>
                    <ng-container *ngIf="selectedGroup === 'ctv'">Connected TV</ng-container>
                    SSPs
                  </ng-container>
                </ng-template>
              </h2>
            </div>
            <div class='sidebar-toggler'>
              <button (click)='_onSidebarTogglerClick($event)' class='btn btn-link'>
                <img src="/assets/images/icon-three-bars.svg" alt="Sidebar Icon" />
              </button>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="isSummary">
          <div>
            <h2 class="title">{{currentSideItemMap?.title}}
            </h2>
          </div>
        </ng-container>
        <div class="top-bar-heading">
          <app-new-rankings-main-filter-items [currentMainFilterItems]="currentMainFilterItems"
            [selectedGroup]="selectedGroup"
            (selectMainFilterClick)="selectMainFilter($event.mainFilterItem, $event.option)">
          </app-new-rankings-main-filter-items>
          <div class="results-heading">
            <div class="loader" data-loader="circle-side"></div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!isSummary">
        <div class='results-table-cont'>
          <div class='results-table-scroll-cont' [ngClass]="{'d-none': noResult}">
            <table class='results-table' fixed-table-header [ngClass]="{ sortable: currentConfig?.sortable }"
              *ngIf="gridData?.length > 0 && currentConfig?.gridHeaders | rankingsHeadersSort:currentConfig?.key:selectedGroup:(bp$ | async) as rankingGridHeaders">
              <thead>
                <tr>
                  <ng-container *ngFor="let header of rankingGridHeaders; let last = last;">
                    <ng-container
                      *ngIf="!header.groups || (header.groups && header.groups.indexOf(selectedGroup) >= 0)">
                      <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || (!currentConfig?.notHideDataIfNA && gridData[0][header.key] !== 'N/A')) &&
                          (header | showIf: currentMainFilterItems)">

                        <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                          <th class="{{header?.key}}" (click)="toggleSort(header)">
                            <app-ranking-gridheader-widget-container [header]="header"
                              [widgetComponent]="header?.headerWidgetComponent" [isLast]="last"
                              [enableSearch]="allowSellerInsight" (searchEvent)="searchHandler($event)"
                              [selectedGroup]="selectedGroup">
                            </app-ranking-gridheader-widget-container>
                            <div class="sort-buttons {{header?.sort}}"
                              *ngIf="allowUISort || (header?.sortColumnKey && !isFreemium)">
                              <i class="fa fa-caret-up"></i>
                              <i class="fa fa-caret-down"></i>
                            </div>
                          </th>
                        </ng-container>

                        <ng-template #spacer>
                          <th class="spacer" [style.width]="header?.format">&nbsp;</th>
                        </ng-template>

                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let dataItem of gridData | filter:filterText:'sellerName' | sortBy:sortHeader?.key:sortHeader?.sort"
                  (click)="onRowClick(dataItem)"
                  [ngClass]="{ 'table-row-nav' : allowSellerInsight || allowSellerModal }">
                  <ng-container *ngFor="let header of rankingGridHeaders; index as i">
                    <ng-container
                      *ngIf="!header.groups || (header.groups && header.groups.indexOf(selectedGroup) >= 0)">
                      <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                        <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || (!currentConfig?.notHideDataIfNA && gridData[0][header.key] !== 'N/A')) &&
                          (header | showIf: currentMainFilterItems)">
                          <td class="grid-data-item {{header.key}}" [ngClass]="{'invisible': i > 2 && showAnonForm}">
                            <ng-container *ngIf="header?.widgetComponent">
                              <app-ranking-widget-container [data]="dataItem" [header]="header"
                                [reportId]="currentConfig?.reportId" [widgetComponent]="header.widgetComponent"
                                [selectedGroup]="selectedGroup" [mainFilterItems]="currentMainFilterItems"
                                [key]="header?.key">
                              </app-ranking-widget-container>
                            </ng-container>
                          </td>
                        </ng-container>
                      </ng-container>
                      <ng-template #spacer>
                        <td>&nbsp;</td>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                </tr>
                <div *ngIf="showAnonForm" class="rankings-hide-scores">
                  <div class='anon-unlock-form'>
                    <ng-container *ngIf='!hasSubmittedAnonEmail'>
                      <div class='title'>Enter your company email to unlock all scores</div>
                      <app-rankings-anon-form classRef="rankings-anon-form"
                        (formSubmit)="handleAnonFormSubmit($event)"></app-rankings-anon-form>
                    </ng-container>
                    <ng-container *ngIf='hasSubmittedAnonEmail'>
                      <div class='title'>Thank you for submitting your email.</div>
                    </ng-container>
                  </div>
                </div>
              </tbody>
            </table>
          </div>
          <div class="load-more">
            <button [hidden]="!showLoadMore" *ngIf="!isFreemium" class="btn btn-primary" (click)="loadMore()"> load more
              results</button>
            <button [hidden]="!showLoadingMore" class="btn btn-primary"> loading more results...</button>
            <span [ngClass]="{'d-table': noResult}" class="d-none mt-4 mx-auto">No results found.</span>
          </div>
          <button *ngIf="showLogin" class="btn btn-primary btn-sign-in" (click)="login()">
            <i class="fa fa-unlock"></i> Sign in or register to view more rankings
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="isSummary">
        <div class="container-fluid">
          <div class="row">
            <ng-container *ngFor="let grid of summaryGrids">
              <div class="col-lg-6 summary-grid">
                <div class="summary-grid-cont">
                  <div class="d-flex flex-column flex-wrap align-items-start justify-content-between mb-3">
                    <h2 class="summary-grid-title mb-0">
                      {{grid?.title}}
                      <a class="btn btn-link view-details float-right" (click)="sideNavItemClick(grid.sideNavItem)">View
                        Details</a>
                    </h2>
                    <app-new-rankings-main-filter-items [currentMainFilterItems]="grid?.mainFilterItems"
                      [selectedGroup]="selectedGroup"
                      (selectMainFilterClick)="summaryGridSelectMainFilter(grid, $event.mainFilterItem, $event.option)">
                      >
                    </app-new-rankings-main-filter-items>
                  </div>
                  <div class="divider"></div>
                  <div class="grid-data">
                    <ng-container *ngFor="let dataItem of grid?.data">
                      <div class="grid-data-item">
                        <ng-container *ngFor="let header of grid?.columns">
                          <ng-container *ngIf="header?.widgetComponent">
                            <app-ranking-widget-container [data]="dataItem" [widgetComponent]="header.widgetComponent"
                              [selectedGroup]="selectedGroup" [mainFilterItems]="currentMainFilterItems"
                              [key]="header?.key">
                            </app-ranking-widget-container>
                          </ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="grid?.loading">
                    <div class="loading-overlay"></div>
                    <div class="loading-overlay-text">
                      <i class="fa fa-spinner fa-spin mr-1"></i>
                      Loading Data...
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="modal fade" id="getMoreModal" tabindex="-1" role="dialog" aria-labelledby="getMoreInsightModal"
  aria-hidden="true" #getMoreModal>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Get More Insights with MRT Enterprise
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>You’re attempting to view insights for a Region which is only available in our Enterprise version</p>
        <p class="font-weight-600">
          Gain powerful insights and understand how buyers evaluate their business with MRT Enterprise.
        </p>
        <ul>
          <li>Protect your network from fraud and brand safety risks.</li>
          <li>Provide the data to understand publishers that should automatically be excluded from my network based on
            my own risk tolerance
          </li>
          <li>Make certain my network is made up of publishers without compliance risks and COPPA violations</li>
          <li>Maintain a network with low security risks/data security for my advertisers</li>
          <li>Create a clean supply chain in CTV, Mobile Apps, and Websites and educate myself on CTV specific risks
          </li>
          <li>Create allow/block lists of IVT free and brand safe CTV, Mobile Apps and websites to buy on</li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-talk-expert" data-dismiss="modal" (click)="scheduleDemo()">Talk
          to an Expert
        </button>
        <button type="button" class="btn btn-primary btn-open-default" data-dismiss="modal">View Insights Data for North
          America
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="sellerModal" tabindex="-1" role="dialog" aria-labelledby="sellerModalLabel"
  aria-hidden="true" #sellerModal>
  <div class="modal-dialog modal-fullscreen" role="document">
    <app-rankings-seller-table [selectedGroup]="selectedGroup" [selectedDate]="selectedDate"
      [selectedPlatform]="selectedPlatform" [selectedSeller]="selectedSeller"
      (close)="closeModal()"></app-rankings-seller-table>
  </div>
</div>